import { Injectable, ɵɵdefineInjectable, Directive, Input, HostListener, NgModule, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class UtilService {
    constructor() { }
}
UtilService.ɵfac = function UtilService_Factory(t) { return new (t || UtilService)(); };
UtilService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UtilService, factory: UtilService.ɵfac, providedIn: 'root' });
/** @nocollapse */
UtilService.ctorParameters = () => [];
/** @nocollapse */ UtilService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UtilService_Factory() { return new UtilService(); }, token: UtilService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UtilService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NumberInput {
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown(event) {
        /** @type {?} */
        let e = (/** @type {?} */ (event));
        // Fallback for device not supporting KeyboardEvent.key [XCode Simulator, e.t.c]
        if (e != null && e.key == null && e.keyCode != null) {
            //numeric keycode
            if (e.keyCode >= 48 && e.keyCode <= 57) {
                return true;
            }
        }
        //Keys allowed for editing
        /** @type {?} */
        const allowedKeys = ["Control", "Shift", "Tab", "Backspace", "Insert", "Delete", "Home", "End", "Escape", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        //Also check if key is not a NaN.
        if (allowedKeys.indexOf(e.key) > -1 || !isNaN(parseInt(e.key))) {
            return true;
        }
        else {
            e.preventDefault();
        }
    }
}
NumberInput.ɵfac = function NumberInput_Factory(t) { return new (t || NumberInput)(); };
NumberInput.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NumberInput, selectors: [["", "numberInput", ""]], hostBindings: function NumberInput_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function NumberInput_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { numberInput: "numberInput" } });
NumberInput.propDecorators = {
    numberInput: [{ type: Input }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumberInput, [{
        type: Directive,
        args: [{
                selector: '[numberInput]'
            }]
    }], null, { 
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], numberInput: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    NumberInput.prototype.numberInput;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlphaNumericInput {
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown(event) {
        /** @type {?} */
        let e = (/** @type {?} */ (event));
        // Fallback for device not supporting KeyboardEvent.key [XCode Simulator, e.t.c]
        if (e != null && e.key == null && e.keyCode != null) {
            //numeric keycode
            if (e.keyCode >= 48 && e.keyCode <= 57) {
                return true;
            }
            //alphabet keycodes
            if (e.keyCode >= 65 && e.keyCode <= 90) {
                return true;
            }
        }
        //Keys allowed for editing
        /** @type {?} */
        const allowedKeys = ["Control", "Shift", "Tab", "Backspace", "Insert", "Delete", "Home", "End", "Escape", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        //Also check if key is either alphabet OR !NaN
        if (allowedKeys.indexOf(e.key) > -1 || e.key.match(/[a-z]/i) || !isNaN(parseInt(e.key))) {
            return true;
        }
        else {
            e.preventDefault();
        }
    }
}
AlphaNumericInput.ɵfac = function AlphaNumericInput_Factory(t) { return new (t || AlphaNumericInput)(); };
AlphaNumericInput.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AlphaNumericInput, selectors: [["", "alphaNumericInput", ""]], hostBindings: function AlphaNumericInput_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function AlphaNumericInput_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { alphaNumericInput: "alphaNumericInput" } });
AlphaNumericInput.propDecorators = {
    alphaNumericInput: [{ type: Input }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlphaNumericInput, [{
        type: Directive,
        args: [{
                selector: '[alphaNumericInput]'
            }]
    }], null, { 
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], alphaNumericInput: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AlphaNumericInput.prototype.alphaNumericInput;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilModule {
}
UtilModule.ɵfac = function UtilModule_Factory(t) { return new (t || UtilModule)(); };
UtilModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UtilModule });
UtilModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UtilModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NumberInput,
                    AlphaNumericInput
                ],
                imports: [],
                exports: [
                    NumberInput,
                    AlphaNumericInput
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UtilModule, { declarations: [NumberInput, AlphaNumericInput], exports: [NumberInput, AlphaNumericInput] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EmailValidationService {
    /**
     * @param {?} email
     * @return {?}
     */
    isValid(email) {
        /** @type {?} */
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}
EmailValidationService.ɵfac = function EmailValidationService_Factory(t) { return new (t || EmailValidationService)(); };
EmailValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EmailValidationService, factory: EmailValidationService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EmailValidationService, [{
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PhoneValidationService {
    /**
     * @param {?} phone
     * @return {?}
     */
    isValid(phone) {
        if (!phone) {
            return false;
        }
        if (phone.length != 9) {
            return false;
        }
        if (isNaN(parseInt(phone))) {
            return false;
        }
        /** @type {?} */
        var firstDigit = parseInt(phone.substr(0, 1));
        if (firstDigit < 6 || firstDigit > 9) {
            return false;
        }
        return true;
    }
}
PhoneValidationService.ɵfac = function PhoneValidationService_Factory(t) { return new (t || PhoneValidationService)(); };
PhoneValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PhoneValidationService, factory: PhoneValidationService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhoneValidationService, [{
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LanguageHelper {
    //Summary : determine wheather a character is alphabet.
    //works with Latin (English + Spanish), Greek, Armenian and Cyrillic scripts.
    //does not works with Chinese, Japanese, Arabic, Hebrew.
    //parameter : "c" - case in-sensitive character.
    /**
     * @param {?} c
     * @return {?}
     */
    static isAlphabet(c) {
        return c.toLowerCase() != c.toUpperCase();
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DniValidationService {
    constructor() {
        this.firstCharSubstituteArr = [{ char: 'X', sub: 0 }, { char: 'Y', sub: 1 }, { char: 'Z', sub: 2 }];
        this.dniValidationExpression = "TRWAGMYFPDXBNJZSQVHLCKE";
    }
    //Determine if DNI is Valid
    /**
     * @param {?} dni
     * @return {?}
     */
    isValidDni(dni) {
        //DNI Must be of Length 9.
        if (!dni || dni.length != 9) {
            return false;
        }
        //Work with Upper Case DNI, to remove case validation.
        dni = dni.toUpperCase();
        /** @type {?} */
        var lastCharacter = dni.substr(8, 1);
        if (!LanguageHelper.isAlphabet(lastCharacter)) {
            return false;
        }
        /** @type {?} */
        var firstCharacter = dni.substr(0, 1);
        /** @type {?} */
        var numericalPart;
        //Replace First Character (ifAlphabet) with its substitute numeric value.
        if (isNaN(Number(firstCharacter))) {
            /** @type {?} */
            var firstCharSubstitute = this.firstCharSubstituteArr.find((/**
             * @param {?} fcs
             * @return {?}
             */
            fcs => fcs.char == firstCharacter));
            if (!firstCharSubstitute) {
                return false;
            }
            numericalPart = firstCharSubstitute.sub + dni.substr(1, 7);
        }
        else {
            numericalPart = dni.substr(0, 8);
        }
        /** @type {?} */
        var numericalValue = Number(numericalPart);
        if (isNaN(numericalValue)) {
            return false;
        }
        /** @type {?} */
        var expectedFirstCharIndexInExpression = (numericalValue % 23);
        //The reminder of numeric value must be index of First character in DNI Expression.
        if (this.dniValidationExpression.charAt(expectedFirstCharIndexInExpression) != lastCharacter) {
            return false;
        }
        return true;
    }
}
DniValidationService.ɵfac = function DniValidationService_Factory(t) { return new (t || DniValidationService)(); };
DniValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DniValidationService, factory: DniValidationService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DniValidationService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    DniValidationService.prototype.firstCharSubstituteArr;
    /**
     * @type {?}
     * @private
     */
    DniValidationService.prototype.dniValidationExpression;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ScriptItemModel {
}
if (false) {
    /** @type {?} */
    ScriptItemModel.prototype.name;
    /** @type {?} */
    ScriptItemModel.prototype.src;
    /** @type {?} */
    ScriptItemModel.prototype.loaded;
    /** @type {?} */
    ScriptItemModel.prototype.attachToHead;
    /** @type {?} */
    ScriptItemModel.prototype.deferred;
    /** @type {?} */
    ScriptItemModel.prototype.asynchronous;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StylesheetItemModel {
}
if (false) {
    /** @type {?} */
    StylesheetItemModel.prototype.name;
    /** @type {?} */
    StylesheetItemModel.prototype.href;
    /** @type {?} */
    StylesheetItemModel.prototype.loaded;
    /** @type {?} */
    StylesheetItemModel.prototype.attachToHead;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ScriptLoaderService {
    /**
     * @param {?} document
     */
    constructor(document) {
        this.document = document;
        this.scripts = [];
    }
    /**
     * @param {?} script
     * @return {?}
     */
    load(script) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            /** @type {?} */
            var existingScript = this.scripts.find((/**
             * @param {?} s
             * @return {?}
             */
            s => s.name == script.name));
            // Complete if already loaded
            if (existingScript && existingScript.loaded) {
                console.log('Already loaded...');
                observer.next(existingScript);
                observer.complete();
            }
            else {
                // Add the script
                this.scripts = [...this.scripts, script];
                // Load the script
                /** @type {?} */
                let scriptElement = this.document.createElement("script");
                scriptElement.type = "text/javascript";
                scriptElement.src = script.src;
                scriptElement.defer = script.deferred;
                scriptElement.async = script.asynchronous;
                scriptElement.onload = (/**
                 * @return {?}
                 */
                () => {
                    script.loaded = true;
                    observer.next(script);
                    observer.complete();
                });
                scriptElement.onerror = (/**
                 * @param {?} error
                 * @return {?}
                 */
                (error) => {
                    observer.error(`Couldn't load script ${script.src}\nDetailed Error:\n${error}`);
                });
                /** @type {?} */
                const attachToTagName = script.attachToHead ? 'head' : 'body';
                /** @type {?} */
                const hostElement = this.document.getElementsByTagName(attachToTagName);
                if (hostElement && hostElement.length && hostElement[0]) {
                    hostElement[0].appendChild(scriptElement);
                }
            }
        }));
    }
}
ScriptLoaderService.ɵfac = function ScriptLoaderService_Factory(t) { return new (t || ScriptLoaderService)(ɵngcc0.ɵɵinject(DOCUMENT)); };
ScriptLoaderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ScriptLoaderService, factory: ScriptLoaderService.ɵfac });
/** @nocollapse */
ScriptLoaderService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScriptLoaderService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ScriptLoaderService.prototype.scripts;
    /**
     * @type {?}
     * @private
     */
    ScriptLoaderService.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StylesheetLoaderService {
    /**
     * @param {?} document
     */
    constructor(document) {
        this.document = document;
        this.stylesheet = [];
    }
    /**
     * @param {?} stylesheet
     * @return {?}
     */
    load(stylesheet) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            /** @type {?} */
            var existingStyle = this.stylesheet.find((/**
             * @param {?} s
             * @return {?}
             */
            s => s.name == stylesheet.name));
            // Complete if already loaded
            if (existingStyle && existingStyle.loaded) {
                console.log('Already loaded...');
                observer.next(existingStyle);
                observer.complete();
            }
            else {
                // Add the script
                this.stylesheet = [...this.stylesheet, stylesheet];
                // Load the script
                /** @type {?} */
                let styleElement = this.document.createElement("link");
                styleElement.rel = "stylesheet";
                styleElement.type = "text/css";
                styleElement.href = stylesheet.href;
                styleElement.onload = (/**
                 * @return {?}
                 */
                () => {
                    stylesheet.loaded = true;
                    observer.next(stylesheet);
                    observer.complete();
                });
                styleElement.onerror = (/**
                 * @param {?} error
                 * @return {?}
                 */
                (error) => {
                    observer.error(`Couldn't load stylesheet ${stylesheet.href}\nDetailed Error:\n${error}`);
                });
                /** @type {?} */
                const attachToTagName = stylesheet.attachToHead ? 'head' : 'body';
                /** @type {?} */
                const hostElement = this.document.getElementsByTagName(attachToTagName);
                if (hostElement && hostElement.length && hostElement[0]) {
                    hostElement[0].appendChild(styleElement);
                }
            }
        }));
    }
}
StylesheetLoaderService.ɵfac = function StylesheetLoaderService_Factory(t) { return new (t || StylesheetLoaderService)(ɵngcc0.ɵɵinject(DOCUMENT)); };
StylesheetLoaderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: StylesheetLoaderService, factory: StylesheetLoaderService.ɵfac });
/** @nocollapse */
StylesheetLoaderService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StylesheetLoaderService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    StylesheetLoaderService.prototype.stylesheet;
    /**
     * @type {?}
     * @private
     */
    StylesheetLoaderService.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AlphaNumericInput, DniValidationService, EmailValidationService, NumberInput, PhoneValidationService, ScriptItemModel, ScriptLoaderService, StylesheetItemModel, StylesheetLoaderService, UtilModule, UtilService };

